import Api from '../utils/Api';
import { createNotification } from './notifications';

export const FETCH_TEAMS_REQUEST = 'FETCH_TEAMS_REQUEST';
export const FETCH_TEAMS_SUCCESS = 'FETCH_TEAMS_SUCCESS';
export const FETCH_TEAMS_FAILURE = 'FETCH_TEAMS_FAILURE';

export const FETCH_TEAM_REQUEST = 'FETCH_TEAM_REQUEST';
export const FETCH_TEAM_SUCCESS = 'FETCH_TEAM_SUCCESS';
export const FETCH_TEAM_FAILURE = 'FETCH_TEAM_FAILURE';

export const CREATE_TEAM_REQUEST = 'CREATE_TEAM_REQUEST';
export const CREATE_TEAM_SUCCESS = 'CREATE_TEAM_SUCCESS';
export const CREATE_TEAM_FAILURE = 'CREATE_TEAM_FAILURE';

export const UPDATE_TEAM_REQUEST = 'UPDATE_TEAM_REQUEST';
export const UPDATE_TEAM_SUCCESS = 'UPDATE_TEAM_SUCCESS';
export const UPDATE_TEAM_FAILURE = 'UPDATE_TEAM_FAILURE';

export const FETCH_USERS_REQUEST = 'FETCH_USERS_REQUEST';
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAILURE = 'FETCH_USERS_FAILURE';

export const FETCH_MEMBERS_REQUEST = 'FETCH_MEMBERS_REQUEST';
export const FETCH_MEMBERS_SUCCESS = 'FETCH_MEMBERS_SUCCESS';
export const FETCH_MEMBERS_FAILURE = 'FETCH_MEMBERS_FAILURE';

export const CREATE_MEMBER_REQUEST = 'CREATE_MEMBER_REQUEST';
export const CREATE_MEMBER_SUCCESS = 'CREATE_MEMBER_SUCCESS';
export const CREATE_MEMBER_FAILURE = 'CREATE_MEMBER_FAILURE';

export const UPDATE_MEMBER_REQUEST = 'UPDATE_MEMBER_REQUEST';
export const UPDATE_MEMBER_SUCCESS = 'UPDATE_MEMBER_SUCCESS';
export const UPDATE_MEMBER_FAILURE = 'UPDATE_MEMBER_FAILURE';

export const DELETE_MEMBER_REQUEST = 'DELETE_MEMBER_REQUEST';
export const DELETE_MEMBER_SUCCESS = 'DELETE_MEMBER_SUCCESS';
export const DELETE_MEMBER_FAILURE = 'DELETE_MEMBER_FAILURE';

export const FETCH_STATUS_REQUEST = 'FETCH_STATUS_REQUEST';
export const FETCH_STATUS_SUCCESS = 'FETCH_STATUS_SUCCESS';
export const FETCH_STATUS_FAILURE = 'FETCH_STATUS_FAILURE';

export const UPDATE_STATUS_REQUEST = 'UPDATE_STATUS_REQUEST';
export const UPDATE_STATUS_SUCCESS = 'UPDATE_STATUS_SUCCESS';
export const UPDATE_STATUS_FAILURE = 'UPDATE_STATUS_FAILURE';

export const CREATE_SNAPSHOT_REQUEST = 'UPDATE_SNAPSHOT_REQUEST';
export const CREATE_SNAPSHOT_SUCCESS = 'UPDATE_SNAPSHOT_SUCCESS';
export const CREATE_SNAPSHOT_FAILURE = 'UPDATE_SNAPSHOT_FAILURE';

export const FETCH_TEAM_ACTIVITY_REQUEST = 'FETCH_TEAM_ACTIVITY_REQUEST';
export const FETCH_TEAM_ACTIVITY_SUCCESS = 'FETCH_TEAM_ACTIVITY_SUCCESS';
export const FETCH_TEAM_ACTIVITY_FAILURE = 'FETCH_TEAM_ACTIVITY_FAILURE';

const fetchTeamsRequest = () => ({
  type: FETCH_TEAMS_REQUEST
});

const fetchTeamsSuccess = teams => ({
  type: FETCH_TEAMS_SUCCESS,
  teams
});

const fetchTeamsFailure = () => ({
  type: FETCH_TEAMS_FAILURE
});

export const fetchTeams = () => dispatch => {
  dispatch(fetchTeamsRequest());
  return Api.getTeams()
    .then(data => dispatch(fetchTeamsSuccess(data)))
    .catch(error => dispatch(fetchTeamsFailure(error)));
};

const fetchTeamRequest = () => ({
  type: FETCH_TEAM_REQUEST
});

const fetchTeamSuccess = team => ({
  type: FETCH_TEAM_SUCCESS,
  team
});

const fetchTeamFailure = error => dispatch => {
  const errorMessage = {
    text: error.message,
    type: 'error'
  };
  dispatch(createNotification([errorMessage]));
  return {
    type: FETCH_TEAM_FAILURE
  };
};

export const fetchTeam = teamId => dispatch => {
  dispatch(fetchTeamRequest());
  return Api.getTeam(teamId)
    .then(data => dispatch(fetchTeamSuccess(data)))
    .catch(error => dispatch(fetchTeamFailure(error)));
};

const updateTeamRequest = () => ({
  type: UPDATE_TEAM_REQUEST
});

const updateTeamSuccess = team => dispatch => {
  const messages = [{ text: 'Team info updated.', type: 'success' }];
  dispatch(createNotification(messages));
  return {
    type: UPDATE_TEAM_SUCCESS,
    team
  };
};

const updateTeamFailure = error => dispatch => {
  error.response.json().then(messages => {
    const errorMessages = messages.map(message => ({
      text: message,
      type: 'error'
    }));
    dispatch(createNotification(errorMessages));
    return {
      type: UPDATE_TEAM_FAILURE
    };
  });
};

export const updateTeam = (teamId, params) => dispatch => {
  dispatch(updateTeamRequest());
  return Api.updateTeam(teamId, params)
    .then(data => dispatch(updateTeamSuccess(data)))
    .catch(error => dispatch(updateTeamFailure(error)));
};

const createTeamRequest = () => ({
  type: CREATE_TEAM_REQUEST
});

const createTeamSuccess = team => dispatch => {
  const messages = [{ text: 'Team created.', type: 'success' }];
  dispatch(createNotification(messages));
  return {
    type: CREATE_TEAM_SUCCESS,
    team
  };
};

const createTeamFailure = error => dispatch => {
  error.response.json().then(messages => {
    const errorMessages = messages.map(message => ({
      text: message,
      type: 'error'
    }));
    dispatch(createNotification(errorMessages));
    return {
      type: CREATE_TEAM_FAILURE
    };
  });
};

export const createTeam = params => dispatch => {
  dispatch(createTeamRequest());
  return Api.createTeam(params)
    .then(data => dispatch(createTeamSuccess(data)))
    .catch(error => dispatch(createTeamFailure(error)));
};

const clearTeamSuccess = () => ({
  type: FETCH_TEAM_SUCCESS,
  team: undefined
});

export const clearTeam = () => dispatch => {
  dispatch(clearTeamSuccess());
};

const fetchUsersRequest = () => ({
  type: FETCH_USERS_REQUEST
});

const fetchUsersSuccess = users => ({
  type: FETCH_USERS_SUCCESS,
  users
});

const fetchUsersFailure = () => ({
  type: FETCH_USERS_FAILURE
});

export const fetchUsers = teamId => dispatch => {
  dispatch(fetchUsersRequest());
  return Api.getTeamUsers(teamId)
    .then(data => dispatch(fetchUsersSuccess(data)))
    .catch(error => dispatch(fetchUsersFailure(error)));
};

const fetchMembersRequest = () => ({
  type: FETCH_MEMBERS_REQUEST
});

const fetchMembersSuccess = users => ({
  type: FETCH_MEMBERS_SUCCESS,
  users
});

const fetchMembersFailure = () => ({
  type: FETCH_MEMBERS_FAILURE
});

export const fetchMembers = teamId => dispatch => {
  dispatch(fetchMembersRequest());
  return Api.getTeamMembers(teamId)
    .then(data => dispatch(fetchMembersSuccess(data)))
    .catch(error => dispatch(fetchMembersFailure(error)));
};

const createMemberRequest = () => ({
  type: CREATE_MEMBER_REQUEST
});

const createMemberSuccess = member => dispatch => {
  const messages = [{ text: 'Invitation sent', type: 'success' }];
  dispatch(createNotification(messages));
  return {
    type: CREATE_MEMBER_SUCCESS,
    member
  };
};

const createMemberFailure = error => dispatch => {
  error.response.json().then(messages => {
    const errorMessages = messages.map(message => ({
      text: message,
      type: 'error'
    }));
    dispatch(createNotification(errorMessages));
    return {
      type: CREATE_MEMBER_FAILURE
    };
  });
};

export const createMember = (teamId, params) => dispatch => {
  dispatch(createMemberRequest());
  return Api.createTeamMember(teamId, params)
    .then(data => dispatch(createMemberSuccess(data)))
    .catch(error => dispatch(createMemberFailure(error)));
};

const updateMemberRequest = () => ({
  type: UPDATE_MEMBER_REQUEST
});

const updateMemberSuccess = member => dispatch => {
  const messages = [{ text: 'Team member updated', type: 'success' }];
  dispatch(createNotification(messages));
  return {
    type: UPDATE_MEMBER_SUCCESS,
    member
  };
};

const updateMemberFailure = error => dispatch => {
  error.response.json().then(messages => {
    const errorMessages = messages.map(message => ({
      text: message,
      type: 'error'
    }));
    dispatch(createNotification(errorMessages));
    return {
      type: UPDATE_MEMBER_FAILURE
    };
  });
};

export const updateMember = (teamId, memberId, params) => dispatch => {
  dispatch(updateMemberRequest());
  return Api.updateTeamMember(teamId, memberId, params)
    .then(data => dispatch(updateMemberSuccess(data)))
    .catch(error => dispatch(updateMemberFailure(error)));
};

const deleteMemberRequest = () => ({
  type: DELETE_MEMBER_REQUEST
});

const deleteMemberSuccess = member => dispatch => {
  const messages = [{ text: 'Team member removed', type: 'success' }];
  dispatch(createNotification(messages));
  return {
    type: DELETE_MEMBER_SUCCESS,
    member
  };
};

const deleteMemberFailure = error => dispatch => {
  error.response.json().then(messages => {
    const errorMessages = messages.map(message => ({
      text: message,
      type: 'error'
    }));
    dispatch(createNotification(errorMessages));
    return {
      type: DELETE_MEMBER_FAILURE
    };
  });
};

export const deleteMember = (teamId, memberId) => dispatch => {
  dispatch(deleteMemberRequest());
  return Api.deleteTeamMember(teamId, memberId)
    .then(data => dispatch(deleteMemberSuccess(data)))
    .catch(error => dispatch(deleteMemberFailure(error)));
};

const fetchStatusRequest = () => ({
  type: FETCH_STATUS_REQUEST
});

const fetchStatusSuccess = status => ({
  type: FETCH_STATUS_SUCCESS,
  status
});

const fetchStatusFailure = () => ({
  type: FETCH_STATUS_FAILURE
});

export const fetchStatus = teamId => dispatch => {
  dispatch(fetchStatusRequest());
  return Api.getStatus(teamId)
    .then(data => dispatch(fetchStatusSuccess(data)))
    .catch(error => dispatch(fetchStatusFailure(error)));
};

const updateStatusRequest = () => ({
  type: UPDATE_STATUS_REQUEST
});

const updateStatusSuccess = status => ({
  type: UPDATE_STATUS_SUCCESS,
  status
});

const updateStatusFailure = (teamId, error) => dispatch => {
  const errorMessage = {
    text: `Something went wrong, please try again (${error.message})`,
    type: 'error'
  };
  dispatch(createNotification([errorMessage]));
  return Api.getStatus(teamId)
    .then(data =>
      dispatch({
        type: UPDATE_STATUS_FAILURE,
        status: data
      })
    )
    .catch(() =>
      dispatch({
        type: UPDATE_STATUS_FAILURE
      })
    );
};

export const updateStatus = (teamId, params) => dispatch => {
  dispatch(updateStatusRequest());
  return Api.updateStatus(teamId, params)
    .then(data => dispatch(updateStatusSuccess(data)))
    .catch(error => dispatch(updateStatusFailure(teamId, error)));
};

const createSnapshotRequest = () => ({
  type: CREATE_SNAPSHOT_REQUEST
});

const createSnapshotSuccess = snapshot => ({
  type: CREATE_SNAPSHOT_SUCCESS,
  snapshot
});

const createSnapshotFailure = () => ({
  type: CREATE_SNAPSHOT_FAILURE
});

export const createSnapshot = (teamId, params) => dispatch => {
  dispatch(createSnapshotRequest());
  return Api.createSnapshot(teamId, params)
    .then(data => dispatch(createSnapshotSuccess(data)))
    .catch(error => dispatch(createSnapshotFailure(error)));
};

const fetchTeamActivityRequest = () => ({
  type: FETCH_TEAM_ACTIVITY_REQUEST
});

const fetchTeamActivitySuccess = activity => ({
  type: FETCH_TEAM_ACTIVITY_SUCCESS,
  activity
});

const fetchTeamActivityFailure = () => ({
  type: FETCH_TEAM_ACTIVITY_FAILURE
});

export const fetchTeamActivity = (teamId, params) => dispatch => {
  dispatch(fetchTeamActivityRequest());
  return Api.getTeamActivity(teamId, params)
    .then(data => dispatch(fetchTeamActivitySuccess(data)))
    .catch(error => dispatch(fetchTeamActivityFailure(error)));
};



// WEBPACK FOOTER //
// ./src/actions/teams.js